import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=4b561aba&scoped=true"
import script from "./Support.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Support.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./Support.vue?vue&type=style&index=0&id=4b561aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b561aba",
  null
  
)

export default component.exports